import { CLOSE_MODAL_DIALOG, OPEN_MODAL_DIALOG } from '../actions/modalDialogs';

const modalDialogs = (state = 0, action = undefined) => {
    switch (action.type) {
        case OPEN_MODAL_DIALOG:
            return state + 1;
        case CLOSE_MODAL_DIALOG:
            return state - 1;
        default:
            return state;
    }
};

export default modalDialogs;
